export enum ProductReportTypes {
    RuleDependent = 'ExecuteRuleBased',
    HtmlDependet = 'ExecuteWordBased',
    PDFDependet = 'ExecutePDFBased',
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/productReportTypes.enum.ts